import { createMultiStyleConfigHelpers } from '@chakra-ui/styled-system';
import Breakpoints from '../../design-utils/breakpoints';

// This function creates a set of function that helps us create multipart component styles.
const helpers = createMultiStyleConfigHelpers([]);

const SellingPlanSelector = helpers.defineMultiStyleConfig({
  baseStyle: {
    SellingPlanSelectorContainer: {
      margin: '0 auto',
      width: '60%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'space-around',
      [`@media screen and (max-width: ${Breakpoints.md})`]: {
        width: '100%',
        margin: '0',
        padding: '0 1rem',
      },
    },
    SellingPlanElementsContainer: {
      margin: '1rem 0',
      display: 'flex',
      flexWrap: 'wrap',
      gap: '1rem',
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%',
      '.bundleapp-selectwrap': {
        position: 'relative',
        width: '100%',
      },
    },
    SelectPlanButton: {
      transition: 'all 0.15s ease-in-out',
      cursor: 'pointer',
      display: 'inline-block',
      fontSize: 'max(1em, 12px)',
      lineHeight: 'max(1em, 20px)',
      color: '#000000',
      background: '#ffffff',
      '&[data-selected="true"]': {
        color: '#ffffff',
        background: '#000000',
      },
      fontWeight: '700',
      textAlign: 'center',
      border: '1px solid #000000',
      padding: '8px 20px',
      boxSizing: 'border-box',
      borderRadius: '4px',
      height: 'fit-content',
      maxHeight: '100%',
      minWidth: '78px',
      minHeight: '30px',
      '&:focus-within': {
        outline: '#9ac3ed auto 3px',
      },
      input: {
        clipPath: 'polygon(0 0) !important',
        height: '0 !important',
        width: '0 !important',
        opacity: '0 !important',
        padding: '0 !important',
        margin: '0 !important',
        border: '0 !important',
      },
      [`@media screen and (max-width: ${Breakpoints.md})`]: {
        borderRadius: '16px',
        scrollSnapAlign: 'center',
        '&:not(:last-child)': {
          marginRight: '1rem',
        },
      },
    },
    Heading: {
      fontSize: '2rem',
      fontWeight: 'bold',
      textAlign: 'center',
    },
  },
  sizes: {},
  variants: {},
  defaultProps: {},
});

export default SellingPlanSelector;
